import React, { Component } from 'react'
import { Link } from 'react-router';
import LinkButton from '../../../components/Buttons/linkButton'

export default class  MenuItemView extends Component {
	render(){
		const { name, url } = this.props;
		return (
			<LinkButton
        to={url}
        text={name}
        classes="btn-menu" />
		)
	}
}



// WEBPACK FOOTER //
// ./src/features/commons/Menu/MenuItem.js